import { Config } from "../config/Config";
import { oauthClient } from "./OAuthClient";

// Selbstverwaltung des eigenen Kontos DIREKT bei LoginWithSengi (nginx /auth/*, kein PortalBackend-
// Relay) - Vertrag: ../LoginWithSengi/API.md "Update profile (self-service, 2026-09-21)".
// Die Basis-URL leitet sich aus VITE_AUTH_URL ab (.../auth/login) - keine eigene Env-Variable noetig.
const accountBaseUrl = () => `${new URL(Config.json.AuthUrl).origin}/auth/v1/account`;

export interface ProfileUpdate {
    displayName?: string;
    preferredLanguage?: 'de' | 'en';
}

export type ProfileUpdateResult =
    | { ok: true; displayName: string | null; preferredLanguage: 'de' | 'en' | null }
    | { ok: false; status: number; error: string };

export class ApiAccount {
    // PATCH /v1/account/profile - Teil-Update. 400 bei ungueltigen Werten (displayName 1-50 Zeichen,
    // keine Steuerzeichen; Sprache 'de'|'en'), 401 ohne gueltigen Token.
    static UpdateProfile = async (update: ProfileUpdate): Promise<ProfileUpdateResult> => {
        const token = oauthClient.getAccessToken();
        if (!token) return { ok: false, status: 401, error: 'not logged in' };
        try {
            const res = await fetch(`${accountBaseUrl()}/profile`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(update),
            });
            const data = await res.json().catch(() => null);
            if (!res.ok) return { ok: false, status: res.status, error: data?.error ?? `HTTP ${res.status}` };
            return { ok: true, displayName: data?.displayName ?? null, preferredLanguage: data?.preferredLanguage ?? null };
        } catch (err) {
            return { ok: false, status: 0, error: err instanceof Error ? err.message : String(err) };
        }
    };
}
